import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/v2/lib/utils"

const fabVariants = cva(
  "relative inline-flex items-center justify-center rounded-2xl shadow-lg transition-all duration-200 active:scale-90",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground active:rounded-xl",
        highlight: "bg-highlight text-primary-foreground active:rounded-xl",
        secondary: "bg-secondary text-secondary-foreground active:rounded-lg",
      },
      size: {
        default: "h-14 w-14 [&_svg]:size-6",
        sm: "h-11 w-11 [&_svg]:size-5 active:!rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

interface FabProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof fabVariants> {}

const Fab = React.forwardRef<HTMLButtonElement, FabProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(fabVariants({ variant, size }), className)}
      {...props}
    />
  )
)
Fab.displayName = "Fab"

export { Fab, fabVariants }
